import { ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { FieldData } from "src/app/share/interface/common.interface";

@Component({
  selector: "app-approve-application",
  templateUrl: "./approve-application.component.html",
  styleUrls: ["./approve-application.component.scss"]
})
export class ApproveApplicationComponent implements OnInit {
  fieldList: FieldData[] = [];
  months: number[] = Array.from({ length: 4 }, (_, i) => (i + 1) * 3);
  renewalFormGroup: FormGroup;
  subscriptions: Subscription[] = [];

  constructor(
    private dialogRef: MatDialogRef<ApproveApplicationComponent>,
    private cd: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: ApproveData
  ) { 
    this.createForm();
    this.listenChanges();
  }

  ngOnInit(): void {
  }

  private createForm() {
    this.renewalFormGroup = this.formBuilder.group({
      insuranceRoadtaxRenewalApplicationAmt: [{ disabled: true, value: this.data.roadtaxRenewalPayment }],
      monthlyInstalmentAmt: [{ disabled: false, value: this.data.monthlyInstallment }],
      instalmentMonths: [this.data.tenure]
    });
  }

  listenChanges(): void {
    this.subscriptions.push(
      this.renewalFormGroup
        .get("instalmentMonths")
        .valueChanges.subscribe((value) => {
          if (!value) return;

          this.onCalculateMonthlyAmt(value, false);
        }),
      );
  }

  onCalculateMonthlyAmt(month: number, isCalcTotal: boolean): void {
    const finalAmt: number = this.data.roadtaxRenewalPayment;
    const monthlyAmt: number = finalAmt / month;
    const roundedAmt: number = Math.round(monthlyAmt * 100) / 100;

    this.renewalFormGroup.get("monthlyInstalmentAmt").patchValue(roundedAmt);
  }

  onSubmit(): void {
    this.dialogRef.close(this.renewalFormGroup.getRawValue());
  }

  onClose(): void {
    this.dialogRef.close(false);
  }
}

interface ApproveData {
  roadtaxRenewalPayment: number;
  monthlyInstallment: number;
  monthlyInstalmentAmt: number;
  tenure: number;
}
